var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystalTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_17901)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F8B165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4H6L4 6V10L6 12H10L12 10V6L10 4Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7971 8.86956C14.2773 8.86956 14.6666 8.48034 14.6666 8.0001C14.6666 7.51986 14.2773 7.13043 13.7971 7.13043C13.3168 7.13043 12.9275 7.51986 12.9275 8.0001C12.9275 8.48034 13.3168 8.86956 13.7971 8.86956Z",
    fill: "#A56C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.058 4.81159C12.5382 4.81159 12.9275 4.42237 12.9275 3.94213C12.9275 3.46189 12.5382 3.07246 12.058 3.07246C11.5777 3.07246 11.1884 3.46189 11.1884 3.94213C11.1884 4.42237 11.5777 4.81159 12.058 4.81159Z",
    fill: "#A56C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 3.07246C8.48025 3.07246 8.86954 2.68324 8.86954 2.203C8.86954 1.72276 8.48025 1.33333 7.99998 1.33333C7.51971 1.33333 7.13041 1.72276 7.13041 2.203C7.13041 2.68324 7.51971 3.07246 7.99998 3.07246Z",
    fill: "#A56C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94201 4.81159C4.42227 4.81159 4.81157 4.42232 4.81157 3.94202C4.81157 3.46173 4.42227 3.07246 3.94201 3.07246C3.46174 3.07246 3.07244 3.46173 3.07244 3.94202C3.07244 4.42232 3.46174 4.81159 3.94201 4.81159Z",
    fill: "#A56C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20293 8.86956C2.68317 8.86956 3.07244 8.48029 3.07244 8C3.07244 7.5197 2.68317 7.13043 2.20293 7.13043C1.7227 7.13043 1.33331 7.5197 1.33331 8C1.33331 8.48029 1.7227 8.86956 2.20293 8.86956Z",
    fill: "#A56C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3623 12.9275C3.84256 12.9275 4.23186 12.5381 4.23186 12.0579C4.23186 11.5776 3.84256 11.1884 3.3623 11.1884C2.88203 11.1884 2.49273 11.5776 2.49273 12.0579C2.49273 12.5381 2.88203 12.9275 3.3623 12.9275Z",
    fill: "#A56C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 14.6667C8.48027 14.6667 8.86954 14.2772 8.86954 13.797C8.86954 13.3168 8.48027 12.9275 8.00004 12.9275C7.5198 12.9275 7.13041 13.3168 7.13041 13.797C7.13041 14.2772 7.5198 14.6667 8.00004 14.6667Z",
    fill: "#A56C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.058 12.9275C12.5382 12.9275 12.9275 12.5381 12.9275 12.0579C12.9275 11.5776 12.5382 11.1884 12.058 11.1884C11.5777 11.1884 11.1884 11.5776 11.1884 12.0579C11.1884 12.5381 11.5777 12.9275 12.058 12.9275Z",
    fill: "#A56C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89579 9.31075L8.95179 10.4059C9.20625 10.6698 9.62689 10.6771 9.89116 10.4223L10.9849 9.36757C11.2492 9.11273 11.257 8.6922 11.0026 8.42831L9.94657 7.33319C9.69211 7.0693 9.27178 7.06207 9.0075 7.31691L7.91376 8.3716C7.64948 8.62644 7.64133 9.04686 7.89579 9.31075Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7681 3.65217H7.13041L8.28983 2.49275L7.71012 1.91304L4.23186 5.3913V4.23188H3.65215V8.86956L2.49273 7.71014L1.91302 8.28985L5.39128 11.7681H3.65215V12.3478H8.86954L7.71012 13.5072L8.28983 14.087L11.7681 10.6087V12.3478H12.3478V7.13043L13.5072 8.28985L14.0869 7.71014L10.6087 4.23188H11.7681V3.65217ZM6.26085 4.23188L4.23186 6.26086V9.73913L6.26085 11.7681H9.73911L11.7681 9.73913V6.26086L9.73911 4.23188H6.26085Z",
    fill: "#A56C2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H16V16H0V0ZM15.6667 0.333333V15.6667H0.333333V0.333333H15.6667Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_17901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalTrack);
export default __webpack_public_path__ + "static/media/CrystalTrack.0752b2ffa6048193be284a993a8205c7.svg";
export { ForwardRef as ReactComponent };